import { Injectable } from '@angular/core';
import { IPageVisibility } from '../../models/page.interface';
import { DisplaySection } from './display/display-section';
import { CameraSection } from './camera/camera-section';
import { DeviceService } from 'src/app/services/device/device.service';
@Injectable({
	providedIn: 'root',
})
export class DisplayCameraPage implements IPageVisibility {
	constructor(
		private displaySection: DisplaySection,
		private cameraSection: CameraSection,
		private deviceService: DeviceService
	) {}

	public async isVisible(): Promise<boolean> {
		// arm hide camera and display;
		const isArm = await this.deviceService.IsArm();
		if (isArm) {
			return false;
		}
		const [isCameraSectionVisible, isDisplaySectionVisible] = await Promise.all([
			this.cameraSection.isVisible(),
			this.displaySection.isVisible(),
		]);

		const isPageVisible = isDisplaySectionVisible || isCameraSectionVisible;
		return isPageVisible;
	}
}
